//优惠活动
export enum RepeatActivity {
  RepeatSubscribe = 301, // 订阅活动
  RepeatWebToApp = 303, //下载活动
  RepeatUserPay = 304, //用户充值奖励
  RepeatUserRegister = 305, //用户注册活动
  RepeatUserRecall = 306, //用户召回活动
  RepeatUserGameBet = 307, //用户投注活动
  RepeatUserLogin = 308, //用户登录活动
  RepeatInviteWheel4 = 401, //邀请转盘4活动
  RepeatCompetition = 312, //竞标赛
}

export enum RepeatCompetitionRankType {
  within = 1, //站内
  without = 2, //站外
}
